<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
            v-if="form && model"
        >
            <rkm-area
                type="fieldset"
                title="Identificação do paciente"
            >
                <FormCidadao
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Profissional responsável"
                show-legend
            >
                <FormProfissional
                    :model="model"
                    :form="form"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Condições avaliadas"
                show-legend
            >
                <FormCondicao
                    :model="model"
                    :form="form"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="CID"
                show-legend
            >
                <FormCID
                    :model="model"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Conclusão"
                show-legend
            >
                <FormConclusao
                    :model="model"
                    :form="form"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Cuidador"
                show-legend
            >
                <FormCuidador
                    :model="model"
                    :form="form"
                />
            </rkm-area>
        </rkm-form>
    </div>
</template>

<script>
import { repository, stringCase, data, object, formats, error, unmask } from "@/mixins"
import { mapActions } from "vuex"
import moment from 'moment'

import FormCidadao from './components/cidadao/Form'
import FormProfissional from './components/profissional/Form'
import FormCondicao from './components/condicao/Form'
import FormCID from './components/cid/Form'
import FormConclusao from './components/conclusao/Form'
import FormCuidador from './components/cuidador/Form'

export default {
    components: {
        FormCidadao,
        FormProfissional,
        FormCondicao,
        FormCID,
        FormConclusao,
        FormCuidador,
    },
    created() {
        this.repositories = {
            avaliacao: this.getConectaSusRepository('atencaoBasica.avaliacao'),
            impressao: null
        }
        this.load()
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if(this.edit) {
                this.setLoading()
                this.repositories.avaliacao.edit(this.id)
                    .then(({ data }) => {
                        this.form = data.form
                        this.model = data.model
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
            else {
                this.setLoading()
                this.repositories.avaliacao.create(this.id)
                    .then(({ data }) => {
                        this.form = data.form
                        this.model = data.model
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.Form.validate()
                .then(valid => {
                    if(!valid) return
                    if(this.edit) {
                        this.setLoading()
                        this.repositories.avaliacao.update(this.id, this.prepareData())
                            .then(({ data }) => {
                                this.showSaveNotification()
                                this.$emit('save', data)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                    else {
                        this.setLoading()
                        this.repositories.avaliacao.store(this.prepareData())
                         .then(({ data }) => {
                            this.showSaveNotification()
                            this.$emit('save', data)
                         })
                         .catch(this.handleError)
                         .finally(() => this.unsetLoading())
                    }
                })
        },
        prepareData() {
            return this.camelObjectKeysToSnakeRecursive({
                'paciente_id': this.model.cidadao.pacienteId,
                'usuario_id': this.model.avaliacao.usuario.id,
                'unidade_id': this.model.avaliacao.unidadeId,
                'infraestrutura_id': this.model.avaliacao.infraestruturaId,
                'equipe_id': this.model.avaliacao.equipeId,
                'ocupacao_id': this.model.avaliacao.ocupacaoId,
                'turno_id': this.model.turno,
                'data': moment(this.model.avaliacao.data).format('YYYY-MM-DD'),
                'procedencia_id': this.model.procedencia,
                'condicoes': this.model.condicoes,
                'cid_primario': this.model.cidPrimario.id,
                'cid_secundario': this.model.cidSecundario ? this.model.cidSecundario.id : null,
                'cid_terciario': this.model.cidTerciario ? this.model.cidTerciario.id : null,
                'conclusao_id': this.model.conclusao,
                'justificativa': this.model.justificativa,
                'cuidador_id': this.model.cuidador,
                'cns_cuidador': this.model.cuidadorCns ? this.unMaskCns(this.model.cuidadorCns) : null,
                'cpf_cuidador': this.model.cuidadorCpf ? this.unMaskCpf(this.model.cuidadorCpf) : null,
                'telefone': {
                    id: this.model.cidadao.telefoneId,
                    numero: this.model.cidadao.telefoneNumero,
                    autorizaSms: this.model.cidadao.telefoneAutorizaSms,
                    atualizado: this.model.cidadao.telefoneAtualizado,
                },
            })
        },
    },
    mixins: [repository, stringCase, data, object, formats, error, unmask],
    props: {
        id: { type: Number, required: true },
        edit: { type: Boolean, default: false }
    }
}
</script>